import { ILink } from '../../../components/NewbuildingInfo';
import {
  trackAboutDeveloperTagClick,
  trackAboutNewbuildingTagClick,
  trackFeedbackTagClick,
  trackRoomsTagClick,
  trackShowOnMapTagClick,
} from '../../../utils/analytics';

export const getNewbuildingLinks = (url: string): ILink[] => {
  return [
    {
      key: 'info',
      title: 'О жилом комплексе',
      url: `${url}#info`,
      onClick: trackAboutNewbuildingTagClick,
    },
    {
      key: 'map',
      title: 'На карте',
      url: `${url}#map`,
      onClick: trackShowOnMapTagClick,
    },
    {
      key: 'flats',
      title: 'Квартиры',
      url: `${url}#filter`,
      onClick: trackRoomsTagClick,
    },
    {
      key: 'builder',
      title: 'Про застройщика',
      url: `${url}#developer`,
      onClick: trackAboutDeveloperTagClick,
    },
    {
      key: 'otzyvy',
      title: 'Отзывы',
      url: `${url}otzyvy`,
      onClick: trackFeedbackTagClick,
    },
  ];
};
